import React, { useContext } from 'react';
import { get } from 'lodash-es';

interface ContextProps {
  lang: Record<string, any>;
  lanType: string;
}

export const LangContext = React.createContext<ContextProps>({ lang: {}, lanType: 'zh-CN' });

interface Props {
  lang: Record<string, any>;
  lanType: string;
  children: React.ReactNode;
}
export const LangContextProvider = (props: Props) => {
  const { lang, lanType, children } = props;

  return <LangContext.Provider value={{ lang, lanType }}>{children}</LangContext.Provider>;
};

// 解决翻译服务中，文案path不对的问题
export const useTranslation = () => {
  const langContext = useContext(LangContext);
  const langMap = langContext?.lang;
  return {
    t: (path: string, defaultValue?: any) => {
      return get(langMap, path, defaultValue);
    },
    lang: langMap,
  };
};

export const useLanType = () => {
  const langContext = useContext(LangContext);
  return langContext.lanType;
};
